const { AnalyticsBrowser } = window.AnalyticsNext || {};

let analytics = null;

if (AnalyticsBrowser && typeof AnalyticsBrowser.load === 'function') {
  analytics = AnalyticsBrowser.load({
    cdnURL: 'https://cdp-eu.customer.io',
    writeKey: process.env.REACT_APP_CUSTOMERIO_API_KEY,
  });
}

export default analytics;